export default {
  "Aumento de valor": 1,
  "Aumento de prazo": 2,
  "Aumento de valor e prazo": 3,
  "Redução de valor": 4,
  "Redução de prazo": 5,
  "Correção de dados": 6,
  "Endosso de cancelamento": 7,
};
